// src/views/ProductPage/ProductDetail.js

import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";

import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Card from "components/Card/Card.js";
import CardBody from "components/Card/CardBody.js";
import Button from "components/CustomButtons/Button.js";
import Parallax from "components/Parallax/Parallax.js";
import KisetsuNavbar from "components/Header/KisetsuNavbar";
import Footer from "components/Footer/Footer.js";
import Favorite from "@material-ui/icons/Favorite";

import { makeStyles } from "@material-ui/core/styles";
import productDetailStyle from "assets/jss/material-kit-pro-react/views/productStyle.js";
import aboutUsStyle from "assets/jss/material-kit-pro-react/views/aboutUsStyle.js";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import "slick-carousel/slick/slick.css"; 
import "slick-carousel/slick/slick-theme.css";
import Slider from "react-slick";
import ProductGallery from "components/ProductGallery/ProductGallery";

const useStyles = makeStyles((theme) => ({
  ...productDetailStyle,
  ...aboutUsStyle,
}));

const ProductDetail = () => {
  const classes = useStyles();
  const { slug } = useParams();
  const [product, setProduct] = useState(null);

  useEffect(() => {
    window.scrollTo(0, 0);
    axios
      .get(`https://ecommerce24.pythonanywhere.com/api/products/${slug}/`)
      .then((res) => setProduct(res.data));
  }, [slug]);

  if (!product) return <div>Yükleniyor...</div>;

  return (
    <>
      <KisetsuNavbar />
<Parallax image={`https://ecommerce24.pythonanywhere.com${product.cover_image}`} filter="dark" small>
        <div className={classes.container}>
          <GridContainer justify="center">
            <GridItem xs={12} sm={12} md={8} className={classes.textCenter}>
              <h1 className={classes.title}>{product.name}</h1>
            </GridItem>
          </GridContainer>
        </div>
      </Parallax>

      <div className={classes.main + " " + classes.mainRaised}>
        <div className={classes.container}>
          <GridContainer spacing={4}>
            {/* Sol taraf: Kapak ve galeri */}
            <GridItem xs={12} sm={6}>
  <Card>
    <CardBody>
<ProductGallery
  coverImage={product.cover_image}
  images={product.images.filter(img => !img.is_cover)}
/>    </CardBody>
  </Card>
</GridItem>


            {/* Sağ taraf: Bilgi ve linkler */}
            <GridItem xs={12} sm={6}>
  <Card plain style={{ boxShadow: "none" }}>
    <CardBody>
      <div style={{ padding: "0 10px" }}>
  <h2 style={{ marginBottom: "10px", fontWeight: "600" }}>{product.name}</h2>

  <div style={{ marginBottom: "8px", fontSize: "16px" }}>
    <strong style={{ color: "#666" }}>Tasarımcı:</strong> {product.designer}
  </div>

  <div style={{ marginBottom: "8px", fontSize: "16px" }}>
    <strong style={{ color: "#666" }}>Ürün Tipi:</strong> {product.product_type}
  </div>

<div style={{ marginBottom: "20px", fontSize: "15px", lineHeight: "1.6", color: "#444" }}>
  <strong style={{ color: "#666" }}>Açıklama:</strong><br />
  <div
    style={{
      whiteSpace: "pre-line",
      fontStyle: "italic",
      marginTop: "5px"
    }}
  >
    {product.description || "Henüz açıklama eklenmemiş."}
  </div>
</div>


  <hr style={{ margin: "20px 0" }} />

{parseFloat(product.discounted_price) > 0 ? (
  <div style={{ marginTop: "10px" }}>
    <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
      <span style={{ textDecoration: "line-through", color: "#999", fontSize: "18px" }}>
        {product.original_price} ₺
      </span>
      <span style={{ fontSize: "22px", fontWeight: "bold", color: "#D32F2F" }}>
        {product.discounted_price} ₺
      </span>
    </div>
    <div style={{ fontSize: "14px", color: "#388E3C", fontWeight: 500, marginTop: "5px" }}>
      %{
        Math.round(
          ((parseFloat(product.original_price) - parseFloat(product.discounted_price)) /
            parseFloat(product.original_price)) *
            100
        )
      } indirim
    </div>
  </div>
) : (
  <h3 style={{ fontSize: "22px", fontWeight: "bold", color: "#000" }}>
    {product.original_price} ₺
  </h3>
)}

  <div style={{ display: "flex", gap: "1rem", flexWrap: "wrap", marginTop: "1rem" }}>
    {product.trendyol_url && (
      <Button
        color="white"
        target="_blank"
        href={product.trendyol_url}
        style={{ backgroundColor: "#F27A1A", color: "#fff" }}
      >
        Trendyol'da Gör
      </Button>
    )}
    {product.hepsiburada_url && (
      <Button
        color="white"
        target="_blank"
        href={product.hepsiburada_url}
        style={{ backgroundColor: "#5D3EBD", color: "#fff" }}
      >
        Hepsiburada'da Gör
      </Button>
    )}
  </div>
</div>

    </CardBody>
  </Card>
</GridItem>

          </GridContainer>
        </div>
      </div>

      <Footer
        content={
          <div>
            <div className={classes.left}>
              <List className={classes.list}>
            <ListItem className={classes.inlineBlock}>
              <a href="/blog-posts" className={classes.block}>Blog</a>
            </ListItem>
            <ListItem className={classes.inlineBlock}>
              <a href="/about-us" className={classes.block}>Hakkımızda</a>
            </ListItem>
            <ListItem className={classes.inlineBlock}>
              <a href="/products" className={classes.block}>Mağaza</a>
            </ListItem>
            <ListItem className={classes.inlineBlock}>
              <a href="/contact-us" className={classes.block}>İletişim</a>
            </ListItem>
          </List>
            </div>
            <div className={classes.right}>
              &copy; {1900 + new Date().getYear()}, sevgiyle tasarlandı{" "}
              <Favorite className={classes.icon} />{" "}
              <a href="/" target="_blank" rel="noopener noreferrer">
                Kisetsu
              </a>{" "}
              ile daha düzenli bir hayat için.
            </div>
          </div>
        }
      />
    </>
  );
};

export default ProductDetail;
